import { BaseFileUploaderAPI, BaseFileUploaderAPIState, BaseFileUploaderAPIStateWithDefaultValues } from '@philips-emr/tws-components';
import { HttpService } from '@philips-emr/tws-core/lib/services';

import { Endpoint } from '../constants';
import { Anexo } from '../interfaces';

import { catchRenderException } from './utils';

function setPredefinedFiles(ieFuncionalidade: number, api: BaseFileUploaderAPI<BaseFileUploaderAPIState, BaseFileUploaderAPIStateWithDefaultValues> | null, ieAplicacaoRegra?: string[]): Promise<Anexo[]> {
  return HttpService.get(Endpoint.GET.CHECK_TIPO_ANEXOS, { ieFuncionalidade, ...(ieAplicacaoRegra && { ieAplicacaoRegra }) })
    .then(response => {
      const { body } = response;

      if (!body) {
        return [];
      }

      const anexos = body as Array<Anexo>;
      const predefinedFiles = anexos.map(regras => {
        const { dsLabelCampo: value, nrSeqRegraAnexo: key, nrSeqTipoDocumento } = regras;
        return { key: String(key), value, nrSeqTipoDocumento: String(nrSeqTipoDocumento) };
      });

      catchRenderException(() => api?.setPredefinedFiles(predefinedFiles));
      return anexos;
    });
}

export {
  setPredefinedFiles,
};
